import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;

export const Option = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
`;

export const Radio = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid #000000;
  margin-right: 15px;
`;

export const Text = styled.p`
  margin-bottom: unset;
  text-align: left;
  font-family: "Mulish";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #222222;
`;
